const appKeyEl = document.querySelector('[http-equiv="X-UA-App-Key"]')
const appKey = appKeyEl ? appKeyEl.getAttribute('content') : ''
const pathnameParts = window.location.pathname.split('/')

module.exports =
  appKey ||
  window.UA_APP_KEY ||
  (pathnameParts[1] === 'admin'
    ? pathnameParts[4] // /admin/flight_deck/apps/<app_key>
    : pathnameParts[2]) // /apps/<app_key>/
